import * as React from "react";

const SvgShowIn = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <mask
      id="show_in_svg__a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="currentColor" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#show_in_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.588 20.413Q4.175 21 5 21h14q.824 0 1.413-.587Q21 19.825 21 19v-7h-2v7H5V5h7V3H5q-.824 0-1.412.587A1.93 1.93 0 0 0 3 5v14q0 .824.587 1.413m16.17-14.85-1.412-1.391L9 13.598V10H7.004v7.012l6.992-.02v-1.996h-3.59z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default SvgShowIn;
